import { HttpClient } from '@adapters/HttpClient';
import { BeepingTeamContacts } from '../../List/models/Clients';

export interface TeamContactsResponse {
    data: BeepingTeamContacts[];
}

export interface CreateTeamContactRequest {
    name: string;
    email?: string;
    phone?: string;
    role?: string;
}

export interface UpdateTeamContactRequest {
    name: string;
    email?: string;
    phone?: string;
    role?: string;
}

export interface TeamContactResponse {
    data: BeepingTeamContacts;
}

export class ClientContactsApiAdapter {
    constructor(private httpClient: HttpClient) { }

    async getContacts(teamId: number): Promise<TeamContactsResponse> {
        const response = await this.httpClient.get<TeamContactsResponse>(
            `/teams/${teamId}/contacts`
        );
        return response;
    }

    async createContact(teamId: number, data: CreateTeamContactRequest): Promise<TeamContactResponse> {
        const response = await this.httpClient.post<TeamContactResponse>(
            `/teams/${teamId}/contacts`,
            data
        );
        return response;
    }

    async updateContact(
        teamId: number,
        contactId: number,
        data: UpdateTeamContactRequest
    ): Promise<TeamContactResponse> {
        const response = await this.httpClient.put<TeamContactResponse>(
            `/teams/${teamId}/contacts/${contactId}`,
            data
        );
        return response;
    }

    async deleteContact(teamId: number, contactId: number): Promise<void> {
        await this.httpClient.delete(`/teams/${teamId}/contacts/${contactId}`);
    }
}

